import script from "./BannerSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerSetup.vue?vue&type=script&setup=true&lang=js"

import "./BannerSetup.vue?vue&type=style&index=0&id=601c6fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-601c6fd0"]])

export default __exports__